import type { GroupPanelViewState, ISerializedLeafNode, SerializedDockview, SerializedGridObject } from 'dockview';

/**
 * Get the group with the provided panelId in the list of views from the layout
 * @param layout A Dockview layout object
 * @param panelId The id of the panel to search for
 * @returns The desired group or undefined if not found
 */
export function getLayoutGroupByPanelId(
  layout: SerializedDockview,
  panelId: string
): ISerializedLeafNode<GroupPanelViewState> | undefined {
  let result: SerializedGridObject<GroupPanelViewState> | undefined = undefined;
  searchLayoutForPanelId(layout.grid.root, panelId);
  function searchLayoutForPanelId(layoutGroup: SerializedGridObject<GroupPanelViewState>, id: string) {
    if (Array.isArray(layoutGroup.data)) {
      const data = layoutGroup.data;
      for (const item of data) {
        const res = searchLayoutForPanelId(item, id);
        if (res) {
          return result;
        }
      }
    } else {
      const data = layoutGroup.data;
      if (data.views.includes(id)) {
        result = layoutGroup;
        return result;
      }
    }
  }
  return result;
}
